import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NotificationSettingsPage from "./notificationSettings.page";
import { selectLoading } from "../../../notification";
import { getNotificationSettings, setNotificationSettings } from "../../redux";
import AccessRights from "../../../../configs/constants/accessRights";

const NotificationSettingsPageContainer = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const settings = useSelector((state) => state.transactionReport.settings);
  const isFetching = useSelector((state) =>
    selectLoading(state, getNotificationSettings.typePrefix)
  );

  const canView = useSelector((state) =>
    state.session.accessRights.includes(
      AccessRights.COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_VIEW
    )
  );

  const canViewNotificationSettings = useSelector((state) =>
    state.session.accessRights.includes(
      AccessRights.COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_NOTIFICATION_EDIT
    )
  );

  useEffect(() => {
    if (!canView) {
      navigate("/admin");
    }
  }, [canView]);

  useEffect(() => {
    if (canViewNotificationSettings) {
      dispatch(getNotificationSettings());
    }
  }, [dispatch, canViewNotificationSettings]);

  const handleSubmit = async (values) => {
    const { enabled, emails } = values;
    await dispatch(
      setNotificationSettings({
        enabled: enabled ? "1" : "0",
        emails: emails.join(","),
      })
    );
  };

  if (!canViewNotificationSettings) {
  navigate(`/admin/consumer-engagement?tab=disbursements&summary=companies`, { replace: true });
  return null;
}

  return (
    <NotificationSettingsPage
      handleSubmit={handleSubmit}
      isFetching={isFetching}
      settings={settings}
    />
  );
};

export default NotificationSettingsPageContainer;
